import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import ModalConfirmation from '../modalconfirmation/ModalConfirmation';
import './RetireePortalToggle.scss';

const RetireePortalToggle = ({ 
  onChange, 
  onClick, 
  id, 
  showInRetireePortals = false,
  disabled = false 
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleToggleClick = (e) => {
    e.preventDefault();
    if (!disabled) {
      setShowModal(true);
    }
  };

  const confirmAction = () => {
    const handler = onChange || onClick;
    if (handler) {
      handler(id);
    }
    setShowModal(false);
  };

  const cancelAction = () => {
    setShowModal(false);
  };

  return (
    <div className="retiree-portal-toggle">
      <div className="toggle-control">
        <Form.Check
          type="switch"
          id={`retiree-portal-switch-${id}`}
          label={showInRetireePortals ? "Enabled" : "Disabled"}
          checked={showInRetireePortals}
          onChange={(e) => e.preventDefault()}
          onClick={handleToggleClick}
          disabled={disabled}
          className="custom-switch"
        />
      </div>
      
      <ModalConfirmation
        title="Confirm Action"
        question={`Are you sure you want to ${showInRetireePortals ? 'disable' : 'enable'} this item in the Medicare Portals?`}
        mainAction={confirmAction}
        secondaryAction={cancelAction}
        mainButton="Confirm"
        secondaryButton="Cancel"
        handleShow={setShowModal}
        show={showModal}
      />
    </div>
  );
};

export default RetireePortalToggle;